import { useTranslation } from 'react-i18next';

const LocationCard = ({ venue }) => {
  const { t } = useTranslation();
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  const { latitude, longitude } = venue.coordinate || {};

  const mapsUrl =
    latitude != null && longitude != null
      ? `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
      : null;

  const staticMapUrl =
    apiKey && latitude != null && longitude != null
      ? `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}` +
      `&zoom=15&size=512x300&scale=2&markers=color:0x10bb82%7C${latitude},${longitude}` +
      `&key=${apiKey}`
      : null;

  return (
    <div className="gp-section">
      <div className="gp-location">
        {mapsUrl && (
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="gp-location__map"
            style={
              staticMapUrl ? { backgroundImage: `url(${staticMapUrl})` } : undefined
            }
            aria-label={t('open.preview.venue.openMap')}
          >
            {!staticMapUrl && (
              <div className="gp-location__map-fallback">
                {t('open.preview.venue.openMap')} →
              </div>
            )}
          </a>
        )}
        <div className="gp-location__body">
          <div className="gp-location__eyebrow">
            {t('open.preview.venue.happeningAt')}
          </div>
          <p className="gp-location__name">{venue.name}</p>
          <p className="gp-location__address">{venue.address}</p>
        </div>
      </div>
    </div>
  );
};

export default LocationCard;
